// extracted by mini-css-extract-plugin
module.exports = {"card":"_1EBGv___Card-module__card","title":"_2laba___Card-module__title","content":"_36xOM___Card-module__content"};